<div class="auto-cashout" [hidden]="hasMinMaxFailture">
    <div class="body-text">
        <span>{{ bodyText }}</span>
    </div>
    <div class="box">
        <div class="half">
            <ms-stake
                [showIncrementalStakes]="false"
                [showConfirm]="false"
                [stake]="autocashoutValueString"
                [errors]="hasStakeError$"
                [emptyCharacter]="' '"
                [focusOnLoad]="true"
                [numpadSource]="numpadSource"
                (stakeChanged)="onStakeChanged($event)" />
        </div>

        <div class="button-wrapper half">
            <ms-my-bets-earlypayout-autocashout-button
                [value]="autocashoutValue"
                [btnerror]="validationError"
                [setType]="type"
                [betNumbers]="betNumbers"
                [betTypeInfo]="betTypeInfo"
                (btnerrorChange)="onError($event)" />
        </div>
    </div>

    @if (validationError) {
        <div class="error">
            <div class="error-message">
                <span [innerHTML]="validationError"></span>
            </div>
        </div>
    }

    <div class="keypad">
        <ms-numpad />
    </div>
</div>
<div class="auto-cashout" [hidden]="!hasMinMaxFailture">
    <div class="min-max-title">
        <vn-icon class="min-max-icon" name="theme-not-available" size="32" />
    </div>
    <div class="min-max-text">
        <span class="text">{{ minMaxText }}</span>
    </div>
</div>
